import {registerGlobalInitFunc} from '../modules/observer.ts';
import {toggleElem} from '../utils/dom.ts';

// the user must type the exact branch name, like GitHub's "delete repository" confirmation
export function canConfirmBranchReset(typed: string, branch: string): boolean {
  return branch !== '' && typed === branch;
}

// the list only knows the divergence from the default branch, so the count is unknown for other targets
export function branchResetDiscardedCommits(target: string, defaultBranch: string, commitsAhead: string | null): number | null {
  if (!defaultBranch || target !== defaultBranch || commitsAhead === null) return null;
  const count = parseInt(commitsAhead);
  return Number.isNaN(count) ? null : count;
}

function initRepoBranchReset(modal: HTMLFormElement) {
  const branchInput = modal.querySelector<HTMLInputElement>('input[name=branch]')!;
  const oldCommitInput = modal.querySelector<HTMLInputElement>('input[name=old_commit_id]')!;
  const targetSelect = modal.querySelector<HTMLSelectElement>('select[name=target]')!;
  const confirmInput = modal.querySelector<HTMLInputElement>('input[name=confirm_branch]')!;
  const discarded = modal.querySelector<HTMLElement>('.reset-branch-discarded')!;
  const okButton = modal.querySelector<HTMLButtonElement>('.ok.button')!;
  const defaultBranch = modal.getAttribute('data-default-branch')!;
  let commitsAhead: string | null = null;

  const updateConfirm = () => {
    okButton.disabled = !canConfirmBranchReset(confirmInput.value, branchInput.value);
  };
  const updateDiscarded = () => {
    const count = branchResetDiscardedCommits(targetSelect.value, defaultBranch, commitsAhead);
    if (count !== null) discarded.textContent = discarded.getAttribute('data-text')!.replace('%d', String(count));
    toggleElem(discarded, count !== null);
  };

  for (const btn of document.querySelectorAll<HTMLElement>('.show-reset-branch-modal')) {
    btn.addEventListener('click', () => {
      const branch = btn.getAttribute('data-branch-name')!;
      branchInput.value = branch;
      oldCommitInput.value = btn.getAttribute('data-old-commit-id')!;
      commitsAhead = btn.getAttribute('data-commits-ahead');
      for (const el of modal.querySelectorAll('.reset-branch-name')) el.textContent = branch;

      // a branch can't be reset to itself
      for (const option of targetSelect.options) option.disabled = option.value === branch;
      if (targetSelect.selectedOptions[0].disabled) {
        targetSelect.value = Array.from(targetSelect.options).find((option) => !option.disabled)?.value ?? '';
      }

      confirmInput.value = '';
      updateConfirm();
      updateDiscarded();
    });
  }
  confirmInput.addEventListener('input', updateConfirm);
  targetSelect.addEventListener('change', updateDiscarded);
}

export function initRepoBranchResetModal() {
  registerGlobalInitFunc('initRepoBranchReset', initRepoBranchReset);
}
